export const selectSecondDriverTypeIsDeleted = state => state.drivers.secondTypeDriverIsDeleted;
